module.exports = __webpack_public_path__ + "static/media/collapse-chevron.126ea5d6.svg";